import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAllDataContext } from "../context/AllDataContext";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import Animation from "../helper/Animation";
import FooterThree from "../components/FooterThree";
import SearchSection from "../components/SearchSection";
import { useLoader } from "../context/LoaderContext";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { fetchSchoolDetails } from "../api/SchoolDetailsApi";

const extractAttributes = (dataArray, section, path) =>
  dataArray.map((item) => ({ id: item.id, ...item, section, path }));

export const combineDataForSearch = (allData) => [
  ...extractAttributes(allData.sliderData || [], "slider", "/"),
  ...extractAttributes(allData.tilesHeaderData || [], "tilesheader", "/"),
  ...extractAttributes(allData.tilesData || [], "tiles", "/programs"),
  ...extractAttributes(allData.aboutData || [], "about", "/"),
  ...extractAttributes(allData.chairmenData || [], "chairmen", "/"),
  ...extractAttributes(allData.chooseUsData || [], "chooseus", "/"),
  ...extractAttributes(allData.highlightsData || [], "highlights", "/"),
  // ...extractAttributes(allData.testimonialHeaderData || [], "testimonialsheader", "/"),
  // ...extractAttributes(allData.testimoniaData || [], "testimonials", "/"),
  // ...extractAttributes(allData.facultyHeaderData || [], "facultyheader", "/faculties"),
  // ...extractAttributes(allData.facultyMemberData || [], "faculty", "/faculties"),
  ...extractAttributes(
    allData.facilitiesData || [],
    "studentlife",
    "/facilities",
  ),
  ...extractAttributes(
    allData.activitiesData || [],
    "studentlife",
    "/activities",
  ),
  ...extractAttributes(
    allData.galleryHeaderData || [],
    "galleryheader",
    "/gallery",
  ),
  ...extractAttributes(allData.galleryImagesData || [], "gallery", "/gallery"),
  ...extractAttributes(allData.bannerData || [], "banner", "/ega"),
  ...extractAttributes(
    allData.visionObjectiveHeaderData || [],
    "visionobjectiveheader",
    "/ega",
  ),
  ...extractAttributes(allData.visionData || [], "vision", "/ega"),
  ...extractAttributes(allData.objectiveData || [], "objective", "/ega"),
  ...extractAttributes(allData.whyEgaData || [], "whyega", "/ega"),
  // ...extractAttributes(allData.certificateHeaderData || [], "certificatesheader", "/about"),
  // ...extractAttributes(allData.certificateListData || [], "certificates", "/about"),
  ...extractAttributes(
    allData.joinCommunityHeaderData || [],
    "communityheader",
    "/ega",
  ),
  ...extractAttributes(
    allData.contactHeaderData || [],
    "contactheader",
    "/contact",
  ),
  ...extractAttributes(
    allData.contactFormHeaderData || [],
    "contactform",
    "/contact",
  ),
  ...extractAttributes(allData.policiesData || [], "policies", "/admission"),
];

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchPage = () => {
  const { setLoading } = useLoader();
  const { schoolDetailsData, setSchoolDetailsData } = useSchoolDetailsContext();
  const query = useQuery().get("query") || "";
  const { allData, setAllData } = useAllDataContext();
  const searchBannerData = allData.allBannerData[0]?.search_title;

  const results = useMemo(() => {
    const lowerQuery = query.toLowerCase();
    return combineDataForSearch(allData).filter((item) =>
      Object.values(item).some(
        (val) =>
          typeof val === "string" && val.toLowerCase().includes(lowerQuery),
      ),
    );
  }, [query, allData]);

  FetchAllApi({ schoolDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (schoolDetailsData.length === 0) {
      Promise.all([fetchSchoolDetails()])
        .then(([schoolDetailsData]) => {
          setSchoolDetailsData(schoolDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [schoolDetailsData.length, setSchoolDetailsData]);

  return (
    <>
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb heading={searchBannerData} title={"Search"} />

      <SearchSection results={results} query={query} />

      <FooterThree />
    </>
  );
};

export default SearchPage;
